@if (skeleton) {
  <p-skeleton width="17rem" height="25rem" borderRadius="20px"></p-skeleton>
} @else {
  <article class="product">
    <figure class="product-thumbnail">
      <img alt="produit" class="product-thumbnail-img" [src]="imageSource" (error)="setImageLoadError($event)" width="176" height="176" />
    </figure>
    <h3 class="product-name">{{ product.product.name }}</h3>
    <div class="product-info">
      <span class="product-price">{{ product.product.price | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}</span>
      <div class="product-quantity">
        <ng-casto-button
          class="primary"
          [faIcon]="faMinus"
          (click)="decrementProductQuantity()"
          [disabled]="product.quantity < 1"></ng-casto-button>
        <p-inputNumber type="number" [ngModel]="product.quantity" (onInput)="onInputChange($event)" [min]="0" locale="fr-FR" />
        <ng-casto-button class="primary" [faIcon]="faPlus" (click)="incrementProductQuantity()"></ng-casto-button>
      </div>
    </div>
    @if (product.quantity > 0) {
      <p class="product-sub-total">
        {{ 'tunnel.purchase-list.sub-total' | translate }} {{ subTotal | currency: 'EUR' : 'symbol' : '1.2-2' : 'fr' }}
      </p>
    }
    <footer class="add-to-cart">
      @if (product.quantity > 0) {
        <ng-casto-button
          class="danger"
          [label]="'tunnel.purchase-list.remove-from-cart' | translate"
          (click)="changeQuantity(0)"></ng-casto-button>
      } @else {
        <ng-casto-button
          class="primary"
          [label]="'tunnel.purchase-list.add-to-cart' | translate"
          (click)="changeQuantity(1)"></ng-casto-button>
      }
    </footer>
  </article>
}
